import { Card } from "../model";
import { CardAdapter } from "./adapter";
import { CardFacade } from "./facade";

export const cardFacade = new CardFacade<Card>();

export const cardAdapter = new CardAdapter();
